module.exports = __webpack_public_path__ + "media/images/crosswave-health-logo-f05b785da8976a5770951562ba45369c.png";